import { HomeworkCardStatuses } from 'src/pages/branch-teachers/HomeworksPage/components/HomeworkCard'
import { baseApi } from 'src/api'

export type HomeworkSolution = {
    id: number;
    userId: number;
    homeworkId: number;
    
    fullname: string;
    avatar: string | null;
    
    status: keyof typeof HomeworkCardStatuses;
    mark: number;
    
    solutionPath: string | null;
    homeworkPath: string;
    
    uploadedAt: number | null;
}


const apiModule = baseApi.injectEndpoints({
    endpoints: builder => ({
        getHomeworkSolutions: builder.query<HomeworkSolution[], {
            params: { groupId: number | string, materialId: number | string }
        }>({
            providesTags: (_res, _err, { params }) => [{
                type: 'HomeworkSolutions',
                id: `${params.groupId}-${params.materialId}`,
            }],
            query: ({ params }) => ({
                url: `/groups/${params.groupId}/materials/${params.materialId}/homework/solutions`,
                method: 'GET',
                errorMessage: 'Не удалось получить информацию по решениям домашних заданий',
            }),
        }),
    }),
})

export const { useGetHomeworkSolutionsQuery } = apiModule